import { Toggle } from '@nexelem/components';
import { get } from 'lodash';
import { useCallback, useEffect, PropsWithChildren } from 'react';
import { useFiltersContext } from '../hooks';
import { RegisterFunction } from '../types/filter.types';

export type FilterToggleRootProps = {
  register: RegisterFunction;
  path: string;
  initialValue?: string;
};

const FilterToggleRoot = ({ path, register, children, initialValue }: PropsWithChildren<FilterToggleRootProps>) => {
  const { onChange, filters } = useFiltersContext();
  const filterValue = get(filters, path, { value: 0, key: '' });

  useEffect(() => {
    register({
      path,
      isMultiple: false,
      value: initialValue,
      key: '',
    });
  }, [path, register]);

  const handleIsSelected = useCallback(
    (value: string | number | number[] | null) => {
      if (value) {
        onChange(path, {
          value,
          key: filterValue.key,
          isMultiple: false,
        });
      }
    },
    [filterValue, onChange, path],
  );

  return (
    <Toggle.Root value={filterValue.value as string} onChange={handleIsSelected}>
      {children}
    </Toggle.Root>
  );
};

export const FilterToggle = {
  Root: FilterToggleRoot,
  Button: Toggle.Button,
};
